import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Badge, Box, Button, Tooltip, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import { useAuth } from '../auth/AuthContext';
import {
  matchNavPath,
  navReviewBadgeSx,
  navTabGroupSx,
  navTabLeadingIconSx,
  navTabSx,
} from '../navigation/navTabStyles';
import { useReviewCounts } from './useReviewCounts';

// Caps the badge number so a large backlog stays readable.
const BADGE_MAX = 9999;

/**
 * Top-level "Review" tab. Links to the spaced-repetition queue and shows the
 * number of due cards as a badge. Category selection lives on the Review page
 * itself (chips), so this is a single labeled tab like Puzzles / Games.
 */
const ReviewMenu: React.FC = () => {
  const { pathname } = useLocation();
  const { authChecked } = useAuth();
  const { counts, loading } = useReviewCounts();

  const onReview = matchNavPath(pathname, '/review');

  return (
    <Box component="span" sx={navTabGroupSx}>
      <Tooltip title="Review (spaced repetition)">
        <Badge
          color="error"
          max={BADGE_MAX}
          badgeContent={authChecked && !loading ? counts.all : undefined}
          overlap="circular"
          sx={navReviewBadgeSx}
        >
          <SchoolIcon sx={navTabLeadingIconSx(onReview)} />
        </Badge>
      </Tooltip>
      <Button
        color="inherit"
        component={Link}
        to="/review"
        aria-label="Review queue"
        sx={navTabSx(onReview)}
      >
        <Typography>Review</Typography>
      </Button>
    </Box>
  );
};

export default ReviewMenu;
